module.exports = {
      id: "search-gray-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#search-gray-color",
      toString: function () {
        return this.url;
      }
    }